import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

const DynamicCreateModal = ({
  show,
  onHide,
  config,
  onSubmit,
  isSubmitting = false
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  // Reset form when modal opens/closes
  React.useEffect(() => {
    if (show) {
      setFormData({});
      setErrors({});
    }
  }, [show]);

  const handleInputChange = (fieldKey, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldKey]: value
    }));

    // Clear error when user starts typing
    if (errors[fieldKey]) {
      setErrors(prev => ({
        ...prev,
        [fieldKey]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    config.fields.forEach(field => {
      if (field.required && !formData[field.key]?.trim()) {
        newErrors[field.key] = `${field.label} is required`;
      }

      // Additional validation rules
      if (formData[field.key] && field.maxLength && formData[field.key].length > field.maxLength) {
        newErrors[field.key] = `${field.label} must be less than ${field.maxLength} characters`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isSubmitting) {
      handleSubmit();
    }
  };

  if (!config) return null;

  return (
    <Modal show={show} onHide={onHide} centered className="border-0" style={{ zIndex: 1070 }}>
      <Modal.Header closeButton>
        <Modal.Title>Create New {config.label}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {config.fields.map((field) => (
          <Form.Group key={field.key} className="mb-3">
            <Form.Label className="fw-bold">
              {field.label}
              {field.required && <span className="text-danger ms-1">*</span>}
            </Form.Label>

            <Form.Control
              type="text"
              value={formData[field.key] || ''}
              onChange={(e) => handleInputChange(field.key, e.target.value)}
              placeholder={field.placeholder || `Enter ${field.label.toLowerCase()}`}
              isInvalid={!!errors[field.key]}
              maxLength={field.maxLength}
              onKeyPress={handleKeyPress}
              disabled={isSubmitting}
            />

            <Form.Control.Feedback type="invalid">
              {errors[field.key]}
            </Form.Control.Feedback>
          </Form.Group>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={isSubmitting}
          style={{ width: "100px" }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={isSubmitting || !config.fields.some(field =>
            field.required && formData[field.key]?.trim()
          )}
          style={{ width: "100px" }}
        >
          {isSubmitting ? `Creating...` : 'Create'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DynamicCreateModal;